import { render, staticRenderFns } from "./EditarFuncionarioPonto.vue?vue&type=template&id=46e6d51c&scoped=true"
import script from "./EditarFuncionarioPonto.vue?vue&type=script&lang=js"
export * from "./EditarFuncionarioPonto.vue?vue&type=script&lang=js"
import style0 from "./EditarFuncionarioPonto.vue?vue&type=style&index=0&id=46e6d51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e6d51c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
